export default "__VITE_ASSET__vRnEopUY__"